import React from "react";
import s from "./index.module.scss";
import Container from "components/layout/Container";

const ProductDetails = (props) => {
    const {
        heading,
        description,
    } = props.fields;

    return (
        <section className={s.section}>
            <Container>
                <h2>{heading}</h2>
                <div dangerouslySetInnerHTML={{ __html: description }} />
            </Container>
        </section>
    );
};

export default ProductDetails;
